<template>
    <customer-layout>
        <div class="relative px-4 py-2 bg-gray-100">
            <div class="flex items-center justify-between">
                <h2 class="text-4xl font-bold text-pink-500">Shop</h2>
                <a href="/cart">
                    <div class="p-4 bg-white border rounded-full shadow-md cursor-pointer">
                        <img src="/img/trolley.png" alt="">
                    </div>
                </a>
            </div>
            <div v-for="category in categories" :key="category.id" class="mt-6 mb-16 md:max-w-screen-xl">
                <h2 class="text-2xl font-semibold capitalize">{{ category.name }}</h2>
                <div class="grid grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                    <div v-for="product in category.category_product" :key="product.id" >
                        <div class="bg-white border border-gray-200 rounded-lg">
                            <div>
                                <img class="rounded-t-lg" :src="`${product.cover_image}`" alt="">
                            </div>
                            <div class="flex flex-col justify-between p-4 cust_height">
                                <h2 class="text-lg font-semibold">{{ product.name }}</h2>
                                <p class="font-light">{{ product.description ? product.description.substr(0, 300) : ""}}</p>
                                <p class="font-light">{{ product.description.substr(301) ? "...." : "" }}</p>
                                <!-- <div>
                                    <span class="text-pink-600">learn more</span>
                                </div> -->
                            </div>
                        </div>
                        <div class="flex items-center justify-between w-full p-2 mt-2 bg-green-400 rounded-lg cursor-pointer" @click="addProductToCart(product.id)">
                            <div class="text-white">add to cart</div>
                            <div class="flex items-center">
                                <div class="pr-2 text-white">{{ product.price }}</div>
                                <img src="/img/icons/coins.svg" class="w-4 h-4">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- success banner -->
            <SuccessBanner v-show="showBanner" :message="message"></SuccessBanner>
            <!-- already exists banner -->
            <WarningBanner v-show="WarningBanner" :message="message"></WarningBanner>
        </div>
    </customer-layout>
</template>
<script>
    import SuccessBanner from "../../Components/PopUpBanner/Success.vue";
    import WarningBanner from "../../Components/PopUpBanner/Warning.vue"
    import CustomerLayout from '../../Layouts/CustomerLayout.vue';

    export default {
        props: ['categories', 'current', 'diamonds'],
        components: {
            SuccessBanner,
            WarningBanner,
            CustomerLayout
        },
        data(){
            return {
                showBanner: false,
                WarningBanner: false,
                message: "",
            }
        },
        methods: {
            addProductToCart(value) {
                let custObj = this;
                const token = localStorage.getItem('token');
                const headers = { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                };
                axios.post("/product/add", {
                    product_id : value
                },{headers})
                .then(function (response) {
                    if(response.data.status == 200) {
                        custObj.message = response.data.message;
                        custObj.showBanner = true;
                        setTimeout(() => {
                            custObj.showBanner = false
                        }, 1000)
                    }
                    if(response.data.status == 400){
                        custObj.message = response.data.message;
                        custObj.WarningBanner = true;
                        setTimeout(() => {
                            custObj.WarningBanner = false
                        }, 2000)
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            }
        }
    }
</script>
<style scoped>
    .cust_height{
        min-height: 12rem;
    }
</style>